import {Component} from '@angular/core';
import {AbstractEditOrmComponent} from "../../AbstractEditOrmComponent";
import {Projeto} from "../../../../domain/Projeto";
import {MetodoAmostragem} from "../../../../domain/MetodoAmostragem";
import {Arquivo} from "../../../../domain/Arquivo";
import {EnumSincronizacao} from "../../../../domain/EnumSincronizacao";

@Component({
  selector: 'app-projeto',
  templateUrl: './edit-projeto.component.html',
  styleUrls: ['./edit-projeto.component.scss'],
})
export class EditProjetoComponent extends AbstractEditOrmComponent<Projeto>  {
  agenciavel = true
  target = Projeto
  urlListagem = "/cadastro/projeto"
  override relations= ['local', 'campanhas', 'metodologias','arquivos']
  override novaEntidade(): Projeto {
    const novo = new Projeto()
    novo.arquivos = []
    novo.agencia_sigla = this.getSiglaAgencia()
    novo.campanhas = []
    novo.metodologias = []
    return novo
  }

  protected override async saveInternal(): Promise<void> {
    this.entidade.situacao=EnumSincronizacao.ENVIAR
    if(this.entidade.metodologias && this.entidade.metodologias.length > 0 ) {
      const repo = this.ds.getRepository(MetodoAmostragem)
      for (const m of this.entidade.metodologias) {
        await repo.save(m)
      }
    }

    if(this.entidade.arquivos && this.entidade.arquivos.length > 0 ) {
      const repo = this.ds.getRepository(Arquivo)
      for (const m of this.entidade.arquivos) {
        await repo.save(m)
      }
    }
    await super.saveInternal();
  }
}
